<template>
  <ValidationProvider rules="required" slim v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio :group="fieldId" :item="1" :label="$t('vatInfo.moreThanTenYearsDescription')" data-cy="tile-more-ten-years" no-uncheck v-model="selection">
          <template>
            <div class="lib__tile__flash" v-html="$t('vatInfo.moreThanTenYears')"></div>
          </template>
        </TileRadio>
        <TileRadio :group="fieldId" :item="0" :label="$t('vatInfo.lessThanTenYearsDescription')" data-cy="tile-less-ten-years" no-uncheck v-model="selection">
          <template>
            <div class="lib__tile__flash" v-html="$t('vatInfo.lessThanTenYears')"></div>
          </template>
        </TileRadio>
      </div>
      <error-message :error="state.errors[0]" data-cy="individual-vat-info-selector-error-message"></error-message>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { IndividualVatInfoSelection } from '@/models'
import FieldBox from '@/components/inputs/Shared/FieldBox'

@Component({
  name: 'individual-vat-info-selector'
})
export default class IndividualVatInfoSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: Number, required: false }) public readonly value!: IndividualVatInfoSelection | null
  //#endregion

  //#region [Computed]
  public get selection(): IndividualVatInfoSelection | null {
    return this.value
  }

  public set selection(val: IndividualVatInfoSelection | null) {
    this.change(val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: IndividualVatInfoSelection | null): IndividualVatInfoSelection | null {
    return value
  }
  //#endregion
}
</script>
